var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":_vm.loading}},[_c('v-card-text',{staticClass:"pa-2 caption black--text"},[_c('apexchart',{attrs:{"type":"heatmap","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }